import { GET_GO_HIGHWAY_UPDATES_SUCCESS, GET_RMIS_UPDATES_SUCCESS } from './rmis.types';

const initialState = {
    rmisSetups: null,
    goHighway: null,
};

export const rmisReducer = (state = initialState, action) => {
    switch (action.type) {

        /** Rmis Settings */
        case GET_RMIS_UPDATES_SUCCESS:
            return {
                ...state,
                rmisSetups: action.payload
            }
        /** End */

      /** Go Highway */
        case GET_GO_HIGHWAY_UPDATES_SUCCESS:
            return {
                ...state,
                goHighway: action.payload
            }
        /** End */

        default:
            return state;
    }
};
